import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 md:pt-28">
        <div className="w-full px-4 md:px-8 lg:px-12 max-w-3xl mx-auto pb-20">
          <nav className="flex items-center gap-2 text-sm mb-8">
            <a href="/" className="text-warm-500 hover:text-brand-600 transition-colors">Home</a>
            <i className="ri-arrow-right-s-line text-warm-400 text-xs" />
            <span className="text-warm-700">Privacy Policy</span>
          </nav>

          <h1 className="font-heading text-3xl md:text-4xl font-bold text-warm-900 mb-6">
            Privacy Policy
          </h1>

          <div className="text-sm md:text-base text-warm-600 leading-relaxed space-y-4">
            <p><strong>Last Updated:</strong> 2026-08-26</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">1. Information We Collect</h2>
            <p>CSSSpreadsheetBR is a static informational website. We do not collect personal data directly. We do not require user registration, login, or form submissions for basic browsing.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">2. Cookies and Tracking</h2>
            <p>We may use basic analytics tools to understand website traffic. These tools may use cookies to track anonymized visitor data such as page views, time on site, and referral sources. No personally identifiable information is collected.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">3. External Links</h2>
            <p>This website contains links to external sites, including kaspreadsheet.com. We are not responsible for the privacy practices or content of these third-party websites. We encourage you to review their privacy policies.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">4. Data Sharing</h2>
            <p>We do not sell, trade, or share any personal data with third parties. This is a content-only website with no user data collection mechanisms.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">5. Changes to This Policy</h2>
            <p>We may update this privacy policy from time to time. Changes will be posted on this page with an updated date.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">6. Contact</h2>
            <p>For privacy-related inquiries, please contact us through the main website.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}